import React from 'react';
import VirtualPOSTransactionsTable from './VirtualPOSTransactionsTable/VirtualPOSTransactionsTable';

function VirtualPOS() {
  return (
    <div className="h-full p-4 flex">
      <div className="w-full h-full">
        <VirtualPOSTransactionsTable />
      </div>
    </div>
  );
}

export default VirtualPOS;
